import React, { useMemo } from 'react';
import { observer } from 'mobx-react';

import { useStores } from 'bringg-web/recipes';
import { getRouteLabel } from '../utils';

interface Props {
	routeId: number;
	routeName: string;
}

function RouteCell({ routeId, routeName }: Props) {
	const { runStore, plannedRoutesStore } = useStores();

	const label = useMemo(() => {
		if (routeName) {
			return routeName;
		}

		const run = runStore.get(routeId);
		const plannedRoute = plannedRoutesStore.get(run?.planned_route_id);

		return getRouteLabel(routeId, run, plannedRoute);
	}, [routeId, routeName, plannedRoutesStore.all]);

	return <span title={label}>{label}</span>;
}

export default observer(RouteCell);
